export default {
  save: 'Speichern',
  confirm: 'Bestätigen',
  cancel: 'Abbrechen',
  delete: 'Löschen',
  complete: 'Ausfüllen',
  loadingTip: 'Wird geladen ...',
  vanPagination: {
    prev: 'Zurück',
    next: 'Weiter',
  },
  vanPullRefresh: {
    pulling: 'Ziehen, um zu aktualisieren...',
    loosing: 'Loslassen, um zu aktualisieren...',
  },
};
